<template>
  <div>
    <v-container class="mb-4">
      <v-row justify="center">
        <v-col>
          <v-card>
            <h2 class="pa-3 text-sm-h4 text-h3 text-center primary--text" v-text="title" />
            <v-card-text>
              <template v-for="(i, index) in achievements">
                <v-row :key="index">
                  <v-col cols="1">
                    <v-img
                      src="/img/HealthView_Icon.png"
                      contain
                      max-height="32"
                    />
                  </v-col>
                  <v-col cols="11">
                    <p class="text-body-2">
                      {{ i.text }}
                    </p>
                  </v-col>
                </v-row>
                <v-divider v-if="index + 1 < achievements.length" :key="`${index}-divider`" class="grey lighten-3 my-2" />
              </template>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'ManagementAchievements',
  data: () => ({
    title: 'Management Achievements',
    achievements: [
      {
        text: 'Managed leading hospice provider in North Carolina for 17 years',
      },
      {
        text:
          'Successfully recapitalized and repositioned a medical device software company leading to a Venture Capital-backed transaction and achieving investor goals',
      },
      {
        text:
          'Integrated the acquisition of a $30 million division of a publicly traded consumer products company, successfully restructuring all aspects of information technology, inventory control and customer     service',
      },
      {
        text:
          'Created a new multi-faceted Oncology Medical Home service offering to improve patient outcomes, quality of life and reduce payer-provider costs. Integrated all payer and provider perspectives into final offering',
      },
      {
        text:
          'Restructured and managed a promotional medical education company with focus on diabetes, pain management and cardiovascular therapeutic areas. Produced web-based applications and creative strategies tailored to the goals of international brand management. Repositioned company-marketing strategies to a national audience of 500,000 physicians.',
      },
    ],
  }),
}
</script>
